<script>
import BasePopup from '../../BasePopup.vue';
import WysiwygToolbar from '../../WysiwygToolbar.vue';
import WysiwygEditor from '../../WysiwygEditor.vue';

export default {
  name: 'TaskViewDescriptionPopup',
  components: { BasePopup, WysiwygToolbar, WysiwygEditor },
  data() {
    return {
      newDescription: '',
    };
  },
  methods: {
    async submit(boolean) {
      if (boolean) {
        this.$emit('submit', this.newDescription);
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<template lang="pug">
BasePopup(@close="submit(false)" :zIndex="9000")
  .description
    .description-header Изменить описание
    .options
      .description-container
        WysiwygToolbar#toolbar
        WysiwygEditor(toolbar="#toolbar" label="Описание задачи" v-model="newDescription")
    .buttons
      Btn(@click="submit(true)" transparent round narrow) Применить
      Btn(@click="newDescription = ''" transparent round narrow) Сбросить
</template>

<style scoped lang="scss">
.description-header {
  display: flex;
  color: rgba(35, 34, 38, 1);
  font-family: Geometria, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.options {
  padding-top: 41px;
  padding-bottom: 35px;
  display: flex;
  gap: 50px;
}

.description-container {
  display: flex;
  flex-direction: column;
  width: 800px;
  gap: 15px;
  align-items: flex-start;
}

.buttons {
  display: flex;
  gap: 30px;
}
</style>
